import http from "./client";

interface ISetSoundSettingQueryParams {
  status: string;
}

async function setSoundSetting(queryParams: ISetSoundSettingQueryParams): Promise<boolean> {
  const response = await http.get('/api/student/setgameficationstatus', {
    params: queryParams,
  });
  return true;
}

const achievements = {
  setSoundSetting,
}


export default achievements;